import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Content } from '../../models';

@Component({ templateUrl: './info.dialog.html' })
export class ContentInfoDialog implements OnInit {
  public displayTopics;
  constructor(
    public dialogRef: MatDialogRef<ContentInfoDialog>,
    @Inject(MAT_DIALOG_DATA) public content: Content) {
  }
  public ngOnInit() {
    this.displayTopics = [];
    if (this.content && this.content.topics && this.content.topics[0] && this.content.topics[0].data && this.content.topics[0].data.name) {
      this.displayTopics = this.content.topics.map((t) => t.data.name);
    }
  }
  public onNoClick() {
    this.dialogRef.close();
  }
}
